import styled from 'styled-components';
import BlueButton from 'Common/Components/BlueButton';

const Button = styled(BlueButton)`
  width: max-content;
  margin: 16px 0 0;
  border-radius: 0;
`;
Button.displayName = 'Button';

export default Button;
